export default "__VITE_ASSET__B08nGs0N__"